module.exports = __webpack_public_path__ + "img/twitter.845b64c8.svg";